import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {RequestTaskSchema} from 'requests/tasks/RequestTaskConstants';
import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {SchemaInterface} from 'schemas/SchemaConstants';
import {StudySchemaQuery} from 'studies/study-schemas/__generated/StudySchemaQuery';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import SettingsField from 'ui-library/SettingsField';

type StudySchema = ExtractByTypename<StudySchemaQuery['studySchema'], 'StudySchemaNode'>;

interface SchemaNameInputProps {
  isWritable: boolean;
  name?: string;
  onNameChange: (name: string) => void;
  schema?: AssaySchema | RequestTaskSchema | SchemaInterface | StudySchema | null;
  dataTestAttrs?: DataTestAttrs;
}

export default function SchemaNameInput(props: SchemaNameInputProps): JSX.Element {
  return (
    <SettingsField
      isBeingCreated={props.schema == null}
      isRequired={true}
      isWritable={props.isWritable}
      label="Name"
      name="name"
      onChange={props.onNameChange}
      value={props.name}
      dataTestAttrs={props.dataTestAttrs}
    />
  );
}
